import React, { useState, useCallback } from 'react';
import {SIFReportingCompanies, SIFFilter} from '../'
import { groupBy } from '../../utils/miscUtil';
import { Chart, Series, Legend, Label, Tooltip,
  ArgumentAxis, ValueAxis} from 'devextreme-react/chart';
import { Button } from 'devextreme-react/button';

const colors = ['#ec5020', '#00a3c8'];

export default function SIFConditionsByCategory(props) {
  const [isFirstLevel, setIsFirstLevel] = useState(true);
  const [title, setTitle] = useState('SIF Conditions by Category');
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState();

  const onFilterDataChanged = useCallback((data) => {
    setFilteredData(data);
    setIsFirstLevel(true);
    var fd = groupBy(data, 'SIF CATEGORY')
    fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
    fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
    setData(fd);

  }, []);

  const customizePoint = useCallback(
    () => ({
      color: colors[Number(isFirstLevel)],
      hoverStyle: !isFirstLevel
        ? {
          hatching: 'none',
        }
        : {},
    }),
    [isFirstLevel],
  );
  const onPointClick = useCallback(
    (e) => {
      if (isFirstLevel) {
        setIsFirstLevel(false);
        let fd = filteredData.filter((item) => item['SIF CATEGORY'] === e.target.originalArgument.toString());
        fd = groupBy(fd,'SIF Condition')
        fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
        fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
        setData(fd);
        setTitle('SIF Conditions for Category: '+e.target.originalArgument.toString())
      }
    },
    [isFirstLevel, setData, setIsFirstLevel, filteredData],
  );
  const onButtonClick = useCallback(() => {
    if (!isFirstLevel) {
      setIsFirstLevel(true);
      var fd = groupBy(filteredData, 'SIF CATEGORY')
      fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
      fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
      setData(fd);
      setTitle('SIF Conditions by Category')
    }
  }, [isFirstLevel, setData, setIsFirstLevel, filteredData]);

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}</div><div class="tooltip-body">`
    txt = txt+`<div>Events: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showPotentialActual={true}
        showCategories={true}
      />
      <h5 className={'mb-2'}>{title}</h5>
      {isFirstLevel && <p>Click a category to see conditions</p>}
      <Button
        className="button-container"
        text="Back"
        icon="chevronleft"
        visible={!isFirstLevel}
        onClick={onButtonClick}
      />
      <Chart
        id="chart"
        customizePoint={customizePoint}
        onPointClick={onPointClick}
        className={isFirstLevel ? 'pointer-on-bars' : ''}
        dataSource={data}
        rotated={true}

      >
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="inside"
          />
        </ArgumentAxis>
        <Series type="bar"
          argumentField="arg"
          valueField="value">
        >
        </Series>
        <ValueAxis>
          <Label
            wordWrap="breakWord"
            position="outside"
          />
        </ValueAxis>
        <Legend visible={false} />
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <SIFReportingCompanies data={filteredData}/>

    </div>
  );
}
